import React from "react";
import styled from "styled-components";
import { colors } from "../../Assets/styles/colors";
import {
  findTranslatedTextForLanguageKey,
  findTranslatedTextForUser,
} from "../../Helpers/chatHelper/ChatHelper";
import { useAuthService } from "../../Context/AuthContext";

const CallTranslatedMessage = ({
  message,
  ownMessage,
  realtimeTranslation,
  useRealtimeApi = false,
}) => {
  const { user } = useAuthService();
  const translationMessage = message?.selected_language_key
    ? findTranslatedTextForLanguageKey(
        message.call_message_translations,
        message.selected_language_key
      )
    : findTranslatedTextForUser(message.call_message_translations, user);

  const translatedText = useRealtimeApi
    ? typeof realtimeTranslation === "string"
      ? realtimeTranslation
      : ""
    : typeof realtimeTranslation === "string"
      ? realtimeTranslation
      : translationMessage?.translation;

  return (
    <Container ownMessage={ownMessage}>
      {!ownMessage && <User>{message?.user?.name}</User>}
      <MessageWrapper>
        <OriginalMessage>{message?.original_message}</OriginalMessage>
        {!ownMessage && <TranslatedMessage>{translatedText}</TranslatedMessage>}
      </MessageWrapper>
    </Container>
  );
};

export default CallTranslatedMessage;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 2px 30px;
  width: 100%;
  align-items: ${({ ownMessage }) => (ownMessage ? "flex-end" : "flex-start")};
  text-align: ${({ ownMessage }) => (ownMessage ? "right" : "left")};
`;

const User = styled.h3`
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  color: ${({ theme }) => theme.menu.selectedTextColor};
  margin: 0;
`;

const MessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0px;
`;

const OriginalMessage = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  color: ${({ theme }) => theme.menu.secondaryTextColor};
  margin: 0;
`;

const TranslatedMessage = styled.p`
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  color: ${({ theme }) => theme.menu.primaryTextColor};
  margin: 0;
`;
